import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";

import SwiperCore, { Autoplay } from "swiper/core";
import AnimatedPage from "../components/AnimatedPage";
import { useForm } from "react-hook-form";
import { useGame } from "../../context/GameContext";

function Home() {
    const url = `${process.env.REACT_APP_API_URL}/auth/getUser`;
    SwiperCore.use([Autoplay]);
    
    const { openGlobalGame } = useGame();

    const swiperParams = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    };
    
    const searchParams = new URLSearchParams(window.location.search);
    const notifyParam = searchParams.get("notify");
    
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [bet, setBet] = useState(JSON.parse(localStorage.getItem("xsmb")));
    
    const [game, setGame] = useState(null);
    const [title, setTitle] = useState(null);
    const [isShow, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    
    const [currentSanhId, setCurrentSanhId] = useState(null);

    // 🔥 STATE QUẢN LÝ POPUP CHỌN SẢNH TÀI XỈU / XÓC ĐĨA 🔥
    const [showSanhPopup, setShowSanhPopup] = useState(false);
    const [selectedGameUrl, setSelectedGameUrl] = useState("");
    const [selectedGameName, setSelectedGameName] = useState("");
    const [gameType, setGameType] = useState("TX"); // "TX" hoặc "XD"

    const avatarsTX = [

         require("../../img/01K7S96R7M0KEYHCTB7D5FEH8Y.webp"),
        require("../../img/01K7S965Z2FXK4Z26CBGRG76ZT.webp"),
        require("../../img/01K7S95HCT42AR8ZVT8GMMGVZX.webp"),
        require("../../img/01K7S94TKJE781BVGF73GD732P.webp"),
        require("../../img/01K7S94AN2PAMCPK7E3DW4C231.webp"),
        require("../../img/01K7S93P3DPBKRR895JKRGZG0E.webp")
       
    ];
      const avatarsXD = [
        require("../../img/01K7S927YBX0EMFMEKDJXMVEQT.webp"),
        require("../../img/01K7S91KDK6Z8HD4WV5DHE09CF.webp"),
        require("../../img/01K7S90X4X7S0Y2GM156AVNHTJ.webp"),
        require("../../img/01K7S90AMEHQH8APRRG9PEN9X6.webp"),
        require("../../img/01K7S8ZHFRR5665EEG5QSJNY50.webp"),
        require("../../img/01K7S8YW8A68866ES70R39HSGF.webp")
    ];
    

    const sanhList = [
        { id: "1", name: "Sảnh A" },
        { id: "2", name: "Sảnh B" },
        { id: "3", name: "Sảnh C" },
        { id: "4", name: "Sảnh D" },
        { id: "5", name: "Sảnh E" },
        { id: "6", name: "Sảnh F" },
    ];

    const handleOpenSanh = (url, name, type) => {
        setSelectedGameUrl(url);
        setSelectedGameName(name);
        setGameType(type); 
        setShowSanhPopup(true);
    };

    const navigate = useNavigate();

    const getProfile = () => {
        axios.get(url).then((res) => {
            if (profile != res.data.data) {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            }
        }).catch(() => localStorage.removeItem("user"));
    };

    useEffect(() => {
        getProfile();
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
        setTimeout(() => {
            axios.get(`https://www.vnlottery.net/api/front/open/lottery/history/list/game?limitNum=4&gameCode=miba`).then((res) => {
                setBet(res.data.t);
                if (bet != res.data.t) {
                    setBet(res.data.t);
                    localStorage.setItem("xsmb", JSON.stringify(res.data.t));
                }
            });
        }, 5000);
    }, []);

    useEffect(() => {
        if (profile) {
            axios.get(`${process.env.REACT_APP_API_URL}/casino/create`).catch(_=>_);
        }
    }, [profile]);

    useEffect(() => {
        const handleBalanceUpdate = () => {
            getProfile();
        };
        window.addEventListener("balanceUpdated", handleBalanceUpdate);
        return () => window.removeEventListener("balanceUpdated", handleBalanceUpdate);
    }, []);

    const [activeOption, setActiveOption] = useState("0");
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };

    const menuGame = (title, product_type, game_type) => {
        setTitle(title);
        setCurrentSanhId(product_type);
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (!res.data.data || res.data.data.length === 0) {
                    swal("Thông báo", "Sảnh game bảo trì", "error");
                    setLoading(false);
                } else {
                    setGame(res.data.data[0] && Array.isArray(res.data.data[0]) ? res.data.data[0] : res.data.data);
                    setLoading(false);
                    setShow(true);
                }
            })
            .catch(() => {
                swal("Thông báo", "Sảnh game bảo trì", "error");
                setLoading(false);
            });
    };

    async function launchGame(params) {
       swal("Thông báo", "Sảnh game đang được bảo trì, vui lòng quay lại sau!", "info");
       return; 
        
        if (!localStorage.getItem("profile")) {
            navigate("/login");
            return;
        }
        const productType = params.product_type || currentSanhId;
        localStorage.setItem("STUCK_GAME_ID", productType);

        if (isLoading) return;
        setLoading(true);

        const form = {
            ...params,
            product_type: productType,
            platform: "html5" 
        };

        let sanhName = "Game";
        const pType = String(productType);
       switch (pType) {
            default: sanhName = "Game"; break;
        }

        try {
            const resLaunch = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (resLaunch.data.data.status == 0) {
                const gameUrl = resLaunch.data.data.game_url;
                const resUser = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
                const money = resUser.data.data.money;

                if (money > 0) {
                    try {
                        await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                            product_type: productType,
                            type: 1, 
                            money: Math.floor(money) 
                        });
                        setProfile({ ...resUser.data.data, money: 0 }); 
                        
                        swal("Thành công", `Đã nạp ${Math.floor(money).toLocaleString("vi-VN")}đ vào sảnh!`, "success", {
                            buttons: false,
                            timer: 1500,
                        });
                    } catch (e) {
                        console.error("Lỗi nạp tiền:", e);
                    }
                }
                openGlobalGame(gameUrl, sanhName, productType);
                setShow(false);
            } else {
                swal("Bảo trì", "Game đang bảo trì, vui lòng thử lại sau.", "error");
            }
        } catch (err) {
            if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                swal("Phiên đăng nhập hết hạn", "Vui lòng đăng nhập lại", "error").then(() => {
                    localStorage.removeItem("user");
                    navigate("/login");
                });
                return;
            }
            swal("Lỗi", err.response?.data?.message || "Không thể kết nối game", "error");
        } finally {
            setLoading(false);
        }
    }

    function handleImageError(e, productCode, tcgGameCode) {
        e.target.onerror = null; 
        e.target.src = `https://images.21947392.com/TCG_GAME_ICONS/${productCode}/EN/${tcgGameCode}.png`;
        e.target.onload = () => {};
        e.target.onerror = () => {
            e.target.src = `https://images.21947392.com/TCG_GAME_ICONS/${productCode}/${tcgGameCode}.png`;
        };
    }

    return (
        <>
            <>
                {isLoading ? (
                    <div className="loading">
                        <div className="loader"></div>
                    </div>
                ) : null}
                <Header profile={profile} style={{ backgroundColor: "#1c1818" }} />
                {swiperParams && notify && (
                    <AnimatedPage>
                        <div style={{ height: "240px", width: "100%", position: "fixed", top: "50px", maxWidth: "450px", zIndex: 10 }}>
                            <div className="box-slide" style={{ overflow: "hidden" }}>
                                <Swiper {...swiperParams}>
                                    {notify.map((item, index) => (
                                        <div key={index}>
                                            {index > 1 && item.title !== "marquee" && item.title !== "popup" && item.isShow === true ? (
                                                <SwiperSlide>
                                                    <img 
                                                        alt={item.title.replace("}", "").replace("{", "")} 
                                                        src={item.image} 
                                                        style={{ 
                                                            width: "100%",        
                                                            height: "130px",        
                                                            objectFit: "cover",     
                                                            borderRadius: "10px",  
                                                            display: "block"       
                                                        }} 
                                                    />
                                                </SwiperSlide>
                                            ) : null}
                                        </div>
										
                                    ))}
                                </Swiper>
                                {notify ? (
                                    <>
                                        {notify[0].isShow === true && notify[0].title === "marquee" ? (
                                            <div className="marquees">
                                                <div>
                                                    <img src={require("../../static/icon_message.png")} />
                                                </div>
                                                <div>
                                                    <div
                                                        className="chaychu"
                                                        style={{ animation: "chuchay " + notify[0].content.length / 10 + "s linear infinite" }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: notify[0].content
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </>
                                ) : null}
                            </div>
                            <div className="wallet-item">
                                <div className="wallet-amount">
                                    {profile ? (
                                        <>
                                            <p>{profile?.username}</p>
                                            <b>{profile ? Math.floor(profile?.money).toLocaleString("vi-VN") : ""}</b>
                                        </>
                                    ) : (
                                        <>
                                            <p>Chào mừng đến với XOSO3M</p>
                                            <b onClick={() => navigate("/login")}>Tham gia ngay</b>
                                        </>
                                    )}
                                </div>
                                <div className="wallet-func">
                                    <div className="wallet-func-item partner">
                                        <a>
                                            <img src={require("../../static/home_top_vip.png")} />
                                            <h3>VIP</h3>
                                        </a>
                                    </div>
                                    <div className="wallet-func-item deposit">
                                        <Link to="/recharge">
                                            <img src={require("../../static/home_top_deposit.png")} />
                                            <h3>NẠP</h3>
                                        </Link>
                                    </div>
                                    <div className="wallet-func-item withdrawal">
                                        <Link to="/withdraw">
                                            <img src={require("../../static/home_top_withdraw.png")} />
                                            <h3>RÚT</h3>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home" style={{ paddingTop: "250px", backgroundColor: "#1c1818" }}>
                            <div className="content-game-home">
                                <div className="content-game-left">
                                    <div className={`menu-game-item ${activeOption === "0" ? "active" : ""}`} onClick={() => handleOptionClick("0")}>
                                        <div className="icon">
    <img src={require("../../static/hotgame-active.png")} />
</div>
                                        <h3 style={{ fontWeight: "bold" }}>HOT</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "7" ? "active" : ""}`} onClick={() => handleOptionClick("7")}>
                                        <div className="icon">
    <img src={require("../../static/cgcp-active.png")} />
</div>
                                        <h3>Xổ Số</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "1" ? "active" : ""}`} onClick={() => handleOptionClick("1")}>
                                        <div className="icon">
    <img src={require("../../static/sp-active.png")} />
</div>
                                        <h3>Thể Thao</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "2" ? "active" : ""}`} onClick={() => handleOptionClick("2")}>
                                       <div className="icon">
    <img src={require("../../static/live-active.png")} />
</div>
                                        <h3>Casino</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "3" ? "active" : ""}`} onClick={() => handleOptionClick("3")}>
                                        <div className="icon">
    <img src={require("../../static/dj-active.png")} />
</div>
                                        <h3>Đá Gà</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "4" ? "active" : ""}`} onClick={() => handleOptionClick("4")}>
                                        <div className="icon">
    <img src={require("../../static/dz-active.png")} />
</div>
                                        <h3>Nổ Hũ</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "5" ? "active" : ""}`} onClick={() => handleOptionClick("5")}>
                                        <div className="icon">
    <img src={require("../../static/qp-active.png")} />
</div>
                                        <h3>Game Bài</h3>
                                    </div>
                                    <div className={`menu-game-item ${activeOption === "6" ? "active" : ""}`} onClick={() => handleOptionClick("6")}>
                                        <div className="icon">
    <img src={require("../../static/by-active.png")} />
</div>
                                        <h3>Bắn Cá</h3>
                                    </div>
                                </div>
                                <div className="content-game-right">
                                    {activeOption === "1" && (
                                        <>
                                            <div className="api-game-flex2" style={{ height: "100%" }}>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "174", game_code: "SB0001" })}
                                                    style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_CGSP_S.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_SBTY_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        SABA
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "151", game_code: "UG2001" })}
                                                    style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_UG.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_ug.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        UG
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "142", game_code: "FB0001" })}
                                                    style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_SBTY.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_FB_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        FB
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "104", game_code: "CMD001" })}
                                                    style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_CMD.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img
                                                            alt=""
                                                            src={require("../../static/logo/logo_cmdbet.png")}
                                                            style={{ height: "40px", width: "auto", marginLeft: "-5px" }}
                                                        />
                                                    </div>
                                                    <small>
                                                        CMD
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => launchGame({ product_type: "54", game_code: "SBO041" })} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_SportsBook.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_SportsBook_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        SBO
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => launchGame({ product_type: "47", game_code: "BTI067" })} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_BTI.png")} style={{ right: "0", width: "130px", top: "30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_BTI_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        BTI
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {activeOption === "2" && (
                                        <>
                                            <div className="api-game-flex2">
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "118", game_code: "WM0001" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_WM.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_WM_night.png")} />
                                                    </div>
                                                    <small>
                                                        WM
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "27", game_code: "DG0013" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_DG.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_DG_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        DG
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "112", game_code: "SEX001" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_AWC.png")} />
                                                    <div className="api-game-logo">
                                                        <img
                                                            alt=""
                                                            src={require("../../static/logo/logo_AWC_night.png")}
                                                            style={{ height: "40px", width: "auto" }}
                                                        />
                                                    </div>
                                                    <small>
                                                        AE
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "86", game_code: "EG0001" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_EVO.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_EVO_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        EVO
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "43", game_code: "MG0001" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_SMGLIVE.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_AGIN_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        AG
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => launchGame({ product_type: "4", game_code: "A00070" })} style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_AGIN.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_SMG_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        MG
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "39", game_code: "PP0141" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_PP1.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_PP_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        PP
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "93", game_code: "SA0001" })}
                                                    style={{ height: "145px" }}>
                                                    <img alt="" src={require("../../static/game/img_SA.png")} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_SA_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        SA
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {activeOption === "3" && (
                                        <>
                                            <div className="api-game-flex2" style={{ height: "100%" }}>
                                                <div
                                                    className="api-game bg"
                                                    onClick={() => launchGame({ product_type: "132", game_code: "SV3002" })}
                                                    style={{ height: "100%", gridColumn: "span 2" }}>
                                                    <img alt="" src={require("../../static/game/img_GA.png")} style={{ right: "0", width: "210px", top: "0%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_sv388_night.png")} style={{ height: "50px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        SV388
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    style={{ height: "100%" }}
                                                    onClick={() => launchGame({ product_type: "135", game_code: "DIG001" })}>
                                                    <img alt="" src={require("../../static/game/img_ODIN.png")} style={{ right: "-10%", width: "210px", bottom: "0" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_DIG.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        DIGMAAN
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                                <div
                                                    className="api-game bg"
                                                    style={{ height: "100%" }}
                                                    onClick={() => launchGame({ product_type: "202", game_code: "WS1682" })}>
                                                    <img alt="" src={require("../../static/game/img_WS168.png")} style={{ right: "-10%", width: "210px", bottom: "0" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_WS168_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        WS168
                                                        <span>1.5%</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {activeOption === "4" && (
                                        <>
                                            <div className="api-game bg" onClick={() => menuGame("Nổ hũ", "140", "RNG")} style={{ height: "135px", marginBottom: "0.2rem" }}>
                                                <img alt="" src={require("../../static/game/img_JILI.png")} style={{ right: "0", width: "230px", top: "-5%" }} />
                                                <div className="api-game-logo">
                                                    <img alt="" src={require("../../static/logo/logo_JILI_night.png")} style={{ height: "50px", width: "auto" }} />
                                                </div>
                                                <small>
                                                    JILI
                                                    <span>2%</span>
                                                </small>
                                            </div>
                                            <div className="api-game-flex2">
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "39", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_SMG.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_PP_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        PP
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "111", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_FC.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_PT.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        PT
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "55", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_JDB.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_JDB_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        JDB
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "141", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_BB.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_FC_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        FC
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "43", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_PP.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_MG.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        MG
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "16", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_PT.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_CQ9_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        CQ9
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "4", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_RICH88.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_AGIN_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        AG
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" style={{ height: "107px" }} onClick={() => menuGame("Nổ hũ", "79", "RNG")}>
                                                    <img alt="" src={require("../../static/game/img_CQ9.png")} style={{ right: "-10%", bottom: "-30%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_BBIN.png")} style={{ height: "35px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        BBIN
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {activeOption === "5" && (
                                        <div className="api-game-flex2" style={{ height: "100%", gridTemplateColumns: "1fr" }}>
                                            <div
                                                className="api-game bg"
                                                onClick={() => launchGame({ product_type: "102", game_code: "LCC001" })}
                                                style={{ height: "100%", marginBottom: "0.2rem" }}>
                                                <img alt="" src={require("../../static/game/img_V8.png")} style={{ right: "-5%", width: "250px", top: "-10%" }} />
                                                <div className="api-game-logo">
                                                    <img alt="" src={require("../../static/logo/logo_V8_night.png")} style={{ height: "50px", width: "auto" }} />
                                                </div>
                                                <small>
                                                    V8
                                                    <span>2%</span>
                                                </small>
                                            </div>
                                            <div
                                                className="api-game bg"
                                                onClick={() => launchGame({ product_type: "121", game_code: "KM0001" })}
                                                style={{ height: "100%", marginBottom: "0.2rem" }}>
                                                <img alt="" src={require("../../static/game/img_WOW.png")} style={{ right: "-5%", width: "250px", top: "-10%" }} />
                                                <div className="api-game-logo">
                                                    <img alt="" src={require("../../static/logo/logo_km.png")} style={{ height: "50px", width: "auto" }} />
                                                </div>
                                                <small>
                                                    KM
                                                    <span>2%</span>
                                                </small>
                                            </div>
                                            <div className="api-game bg" onClick={() => launchGame({ product_type: "123", game_code: "KP0001" })} style={{ height: "100%" }}>
                                                <img alt="" src={require("../../static/game/img_BOLEQP.png")} style={{ right: "-5%", width: "250px", top: "-10%" }} />
                                                <div className="api-game-logo">
                                                    <img alt="" src={require("../../static/logo/logo_KY_night.png")} style={{ height: "50px", width: "auto" }} />
                                                </div>
                                                <small>
                                                    KY
                                                    <span>2%</span>
                                                </small>
                                            </div>
                                        </div>
                                    )}
                                    {activeOption === "6" && (
                                        <>
                                            <div className="api-game-flex2" style={{ height: "100%" }}>
                                                <div className="api-game bg" onClick={() => menuGame("Bắn cá", "141", "FISH")} style={{ height: "100%", gridColumn: "span 2" }}>
                                                    <img alt="" src={require("../../static/game/img_JILIFISH.png")} style={{ right: "-10%", width: "300px", top: "-25%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_FC_night.png")} style={{ height: "50px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        FC
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => menuGame("Bắn cá", "140", "FISH")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_YL.png")} style={{ right: "5%", bottom: "-10%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_JILI_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        JILI
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => menuGame("Bắn cá", "43", "FISH")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_TPFISH.png")} style={{ bottom: "-10%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_SMG_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        MG
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => menuGame("Bắn cá", "16", "FISH")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_FCFISH.png")} style={{ bottom: "-10%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_CQ9_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        CQ9
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => menuGame("Bắn cá", "55", "FISH")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_7.png")} style={{ bottom: "-10%" }} />
                                                    <div className="api-game-logo">
                                                        <img alt="" src={require("../../static/logo/logo_JDB_night.png")} style={{ height: "40px", width: "auto" }} />
                                                    </div>
                                                    <small>
                                                        JDB
                                                        <span>2%</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {activeOption === "7" && (
                                        <>
                                            <div className="api-game-flex2" style={{ height: "100%" }}>
                                                <div className="api-game bg" onClick={() => navigate("/xsmb/lo2")} style={{ height: "100%", gridColumn: "span 2" }}>
                                                    <img alt="" src={require("../../static/game/img_CGCP.png")} style={{ right: "0", width: "170px", top: "0%" }} />
                                                    <div className="api-game-logo" style={{ fontSize: "13px" }}>
                                                       Xổ Số Miền Bắc 6h30
                                                    </div>
                                                    <small>
                                                        <img src={require("../../static/logo/logo_mb_night.png")} />
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => navigate("/xoso")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_mt.png")} style={{ right: "0", width: "160px", bottom: "0", top: "15%" }} />
                                                   <div className="api-game-logo" style={{ fontSize: "15px", top: "5%" }}>
														Miền Trung
                                                    </div>
                                                    <small>
                                                        <img src={require("../../static/logo/logo_mt_night.png")} />
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => navigate("/xoso")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_mn.png")} style={{ right: "0", width: "160px", bottom: "0", top: "15%" }} />
                                                    <div className="api-game-logo" style={{ fontSize: "15px", top: "5%" }}>
														Miền Nam
                                                    </div>
                                                    <small>
                                                        <img src={require("../../static/logo/logo_mn_night.png")} />
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => navigate("/xs75s/lo2")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_mg45.png")} style={{ right: "0", width: "160px", bottom: "0", top: "15%" }} />
                                                    <div className="api-game-logo" style={{ fontSize: "15px", top: "5%" }}>
														Nhanh 45S
                                                    </div>
                                                    <small>
                                                        <img src={require("../../static/logo/logo_st_night.png")} />
                                                    </small>
                                                </div>
                                                <div className="api-game bg" onClick={() => navigate("/xs120s/lo2")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/game/img_st.png")} style={{ right: "0", width: "160px", bottom: "0", top: "15%" }} />
                                                    <div className="api-game-logo" style={{ fontSize: "15px", top: "5%" }}>
														Nhanh 2P
                                                    </div>
                                                    <small>
                                                        <img src={require("../../static/logo/logo_xsvip_night.png")} />
                                                    </small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* 🔥 MENU ITEM 0 (HOT GAME) - ĐÃ SỬA THÀNH MỞ POPUP 6 SẢNH 🔥 */}
                                    {activeOption === "0" && (
                                        <>
                                            <div className="api-game-flex2" style={{ height: "100%" }}>
                                                <div className="api-game bg" onClick={() => navigate("/txmd5")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/txmd5.png")} style={{ right: "0", width: "120px", top: "20%" }} />
                                                    <div className="api-game-logo">Tài Xỉu MD5</div>
                                                    <small><span>60s</span></small>
                                                </div>

                                                <div className="api-game bg" onClick={() => handleOpenSanh("/tx45s", "Tài Xỉu 45 Giây", "TX")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/tx45.png")} style={{ right: "0", width: "120px", top: "20%" }} />
                                                    <div className="api-game-logo">Tài Xỉu 45 Giây</div>
                                                    <small><span>45s</span></small>
                                                </div>

                                                <div className="api-game bg" onClick={() => handleOpenSanh("/tx60s", "Tài Xỉu 60 Giây", "TX")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/tx60.png")} style={{ right: "0", width: "120px", top: "20%" }} />
                                                    <div className="api-game-logo">Tài Xỉu 60S</div>
                                                    <small><span>60s</span></small>
                                                </div>

                                                <div className="api-game bg" onClick={() => handleOpenSanh("/xd45s", "Xóc Đĩa 45 Giây", "XD")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/xd45.png")} style={{ right: "0", width: "125px", top: "20%" }} />
                                                    <div className="api-game-logo">Xóc Đĩa 45S</div>
                                                    <small><span>45s</span></small>
                                                </div>

                                                <div className="api-game bg" onClick={() => handleOpenSanh("/xd60s", "Xóc Đĩa 60 Giây", "XD")} style={{ height: "100%" }}>
                                                    <img alt="" src={require("../../static/xd60.png")} style={{ right: "0", width: "120px", top: "20%" }} />
                                                    <div className="api-game-logo">Xóc Đĩa 60S</div>
                                                    <small><span>60s</span></small>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </AnimatedPage>
                )}
                <Footer />
                
                {/* Popup List Game (Nổ Hũ, Bắn Cá...) */}
                {isShow === true ? (
                    <>
                        <div className="popup-backdrop">
                            <div className="popup-main">
                                <div className="popup-header">{title}</div>
                                <div className="popup-content">
                                    <div className="gameapi-list">
                                        {game != null &&
                                            game.map((item) => (
                                                <div className="gameapi-item" onClick={() => launchGame({ product_type: currentSanhId, game_code: item.tcgGameCode })}>
                                                    <img
                                                        src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`}
                                                        onError={(e) => handleImageError(e, item.productCode, item.tcgGameCode)}
                                                        alt={item.gameName}
                                                    />
                                                    <div className="gameapi-name">{item.gameName}</div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <button onClick={() => setShow(false)} className="popup-close">
                                    Đóng
                                </button>
                            </div>
                        </div>
                    </>
                ) : null}

                {/* 🔥 POPUP CHỌN SẢNH TÀI XỈU / XÓC ĐĨA 🔥 */}
                {showSanhPopup === true ? (
                    <>
                        <div className="popup-backdrop" style={{ zIndex: "9999999", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0,0,0,0.7)" }}>
                            <div className="sanh-popup-modal">
                                <div className="sanh-popup-header">
                                    <span style={{ color: "#f3c242" }}>{selectedGameName}</span> <span style={{ color: "#fff" }}>- Chọn Sảnh</span>
                                </div>
                                
                                <div className="sanh-popup-grid">
                                    {sanhList.map((item, index) => {
                                        const imgSrc = gameType === "TX" ? avatarsTX[index] : avatarsXD[index];
                                        const sanhLetter = ["A", "B", "C", "D", "E", "F"][index];

                                        return (
                                            <div 
                                                key={item.id} 
                                                className="sanh-item"
                                                onClick={() => {
                                                    setShowSanhPopup(false);
                                                    navigate(`${selectedGameUrl}/sanh/${item.id}`);
                                                }}
                                            >
                                                <img src={imgSrc} alt={item.name} className="sanh-img" />
                                             
                                               
                                            </div>
                                        );
                                    })}
                                </div>
                                
                                <button onClick={() => setShowSanhPopup(false)} className="sanh-close-btn">
                                    Đóng
                                </button>
                            </div>
                        </div>
                    </>
                ) : null}

                {profile && notify && isShow && notifyParam != null && (
                    <>
                        {notify.map(
                            (item) =>
                                item.isShow &&
                                item.title === "popup" && (
                                    <div className="popup-backdrop">
                                        <div className="popup-main">
                                            <div className="popup-times" onClick={() => setShow(false)}>
                                                &times;
                                            </div>
                                            <div className="popup-content" style={{ padding: "20px" }}>
                                                {item.content.includes("{") && item.content.includes("}") ? (
                                                    <img
                                                        src={item.content.substring(item.content.indexOf("{") + 1, item.content.indexOf("}"))}
                                                        style={{ width: "100%", height: "auto" }}
                                                    />
                                                ) : (
                                                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                        )}
                    </>
                )}
            </>
            
                                    <style dangerouslySetInnerHTML={{__html: `
                                .sanh-popup-modal {
                    background-color: #404549;
                    width: 90%;
                    max-width: 420px;
                    border-radius: 16px;
                    padding: 20px 20px 30px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.8);
                }
                .sanh-popup-header {
                    text-align: center;
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .sanh-popup-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 20px 15px;
                }
                .sanh-item {
                    background: #ffffff;
                    border-radius: 12px;
                    padding: 4px;
                    position: relative;
                    cursor: pointer;
                    transition: transform 0.2s;
                }
                .sanh-item:hover {
                    transform: scale(1.05);
                }
                .sanh-img {
                    width: 100%;
                    display: block;
                    border-radius: 8px;
                    object-fit: cover;
                }
                .sanh-close-btn {
                    margin: 30px auto 0;
                    display: block;
                    background-color: #10b981;
                    color: #fff;
                    border: none;
                    padding: 10px 45px;
                    border-radius: 25px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: background 0.2s;
                }
                .sanh-close-btn:hover {
                    background-color: #0ea170;
                }

                /* ==================== MENU BÊN TRÁI - NỔI BẬT HƠN + TEXT TRẮNG ==================== */
                .menu-game-item {
                    background-color: #2c2a35 !important;     /* Nền tối sang hơn */
                    margin-bottom: 8px;
                    border-radius: 10px;
                    border: 1px solid #44414f;                 /* Viền nhẹ */
                    transition: all 0.2s ease;
                }

                .menu-game-item:hover {
                    background-color: #363340 !important;     /* Hover sáng hơn */
                    border-color: #ff9d2e;
                }

                .menu-game-item.active {
                    border: 2px solid #ff9d2e !important;
                    background-color: #36334a !important;     /* Nền active nổi bật */
                    color: #ffffff !important;
                }

                .menu-game-item h3,
                .menu-game-item.active h3 {
                    color: #ffffff !important;                /* Text trắng */
                    font-weight: bold;
                }
            `}} />
        </>
    );
}
export default Home;